import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminGuard } from '@/components/AdminGuard';
import { AdminLayout } from '@/components/AdminLayout';
import { SignInPage } from '@/pages/SignInPage';
import { AuthCallbackPage } from '@/pages/AuthCallbackPage';
import { MfaChallengePage } from '@/pages/MfaChallengePage';
import { MfaSetupPage } from '@/pages/MfaSetupPage';
import { AdminAssetsPage } from '@/pages/AdminAssetsPage';
import { AdminOrdersPage } from '@/pages/AdminOrdersPage';
import { AdminOrderDetailPage } from '@/pages/AdminOrderDetailPage';
import { AdminProductsPage } from '@/pages/AdminProductsPage';
import { AdminProductDetailPage } from '@/pages/AdminProductDetailPage';
import { AdminUsersPage } from '@/pages/AdminUsersPage';
import { AdminUserDetailPage } from '@/pages/AdminUserDetailPage';
import { AdminDiscountsPage } from '@/pages/AdminDiscountsPage';
import { AdminCatalogPage } from '@/pages/AdminCatalogPage';
import { AdminCatalogDetailPage } from '@/pages/AdminCatalogDetailPage';
import { AdminPaymentsPage } from '@/pages/AdminPaymentsPage';
import { AdminRenderQueuePage } from '@/pages/AdminRenderQueuePage';
import { AdminPaymentReconciliationPage } from '@/pages/AdminPaymentReconciliationPage';
import { AdminEmailUsagePage } from '@/pages/AdminEmailUsagePage';

export const App = () => {
  return (
    <Routes>
      <Route path="/sign-in" element={<SignInPage />} />
      <Route path="/sign-in/mfa" element={<MfaChallengePage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route
        path="/mfa-setup"
        element={
          <AdminGuard>
            <MfaSetupPage />
          </AdminGuard>
        }
      />
      <Route
        element={
          <AdminGuard>
            <AdminLayout />
          </AdminGuard>
        }
      >
        <Route index element={<Navigate to="/assets" replace />} />
        <Route path="assets" element={<AdminAssetsPage />} />
        <Route path="orders" element={<AdminOrdersPage />} />
        <Route path="orders/:id" element={<AdminOrderDetailPage />} />
        <Route path="payments" element={<AdminPaymentsPage />} />
        <Route path="products" element={<AdminProductsPage />} />
        <Route path="products/:id" element={<AdminProductDetailPage />} />
        <Route path="users" element={<AdminUsersPage />} />
        <Route path="users/:id" element={<AdminUserDetailPage />} />
        <Route path="catalog" element={<AdminCatalogPage />} />
        <Route path="catalog/:id" element={<AdminCatalogDetailPage />} />
        <Route path="discounts" element={<AdminDiscountsPage />} />
        <Route path="render-queue" element={<AdminRenderQueuePage />} />
        <Route path="payment-reconciliation" element={<AdminPaymentReconciliationPage />} />
        <Route path="email-usage" element={<AdminEmailUsagePage />} />
      </Route>
      <Route path="*" element={<Navigate to="/assets" replace />} />
    </Routes>
  );
};
